export default __webpack_public_path__ + "static/media/group-image.69aeb646.svg";